( function () {
    'use strict';
    ( function ( $ ) {
        function slick_officeboxes(){
            var wrapper = $(".office-boxes");
            if(window.innerWidth >= 768) {
                if (wrapper.hasClass('slick-initialized')) {
                    wrapper.slick('unslick');
                }
            }
            else{
                if (!wrapper.hasClass('slick-initialized')) {
                    wrapper.slick({
                        slideToShow: 1,
                        slidesToScroll: 1,
                        autoplay: false,
                        autoplaySpeed: 4000,
                        infinite: true,
                        arrows: true,
                        rows: 0,
                        mobileFirst: true,
                        responsive: [
                            {
                              breakpoint: 767,
                              settings: "unslick"
                            },                
                        ]
                    });
                }
            }
        }
        slick_officeboxes();
        $(window).resize(slick_officeboxes);
    } )( jQuery );
} )();